import { API } from "aws-amplify";
import {fetchIdToken} from "../app/msal";
const request = async (operation) => {
  try {
    const result = await API.graphql(operation);
    return result.data;
  } catch (res) {
    const { errors } = res;
    if (isErr401(errors)) {
      await fetchIdToken();
      return await request(operation);
    }
    throw errors;
  }
};

const isErr401 = (errors = []) => {
  return errors.some(obj => obj.message.includes("401"));
}

export default request;
